import { useEffect, useState } from "react";
import { emptyRankings, rankingsHtml, type Rankings } from "../shared/rankings";
import type { Language } from "../shared/languages";
import type { CatalogResponse } from "./types";

function serverData(): Rankings | null {
  try {
    const text = document.getElementById("agentbuck-rankings")?.textContent;
    return text ? JSON.parse(text) as Rankings : null;
  } catch { return null; }
}

export function RankingsPage({ catalog, language }: { catalog: CatalogResponse; language: Language }) {
  const [initial] = useState(serverData);
  const [data, setData] = useState<Rankings>(initial ?? emptyRankings("unavailable"));
  useEffect(() => {
    if (initial) return;
    const controller = new AbortController();
    void fetch("/api/rankings", { signal: controller.signal }).then(async response => {
      if (!response.ok) throw new Error("Rankings unavailable");
      setData(await response.json() as Rankings);
    }).catch(() => { if (!controller.signal.aborted) setData(emptyRankings("unavailable")); });
    return () => controller.abort();
  }, [initial]);
  return <main className="subpage rankings-page" dangerouslySetInnerHTML={{ __html: rankingsHtml(data, catalog, language) }} />;
}
